//登録フロー：電話番号認証SMS認証　FB認証後遷移もしくはemail登録完了後遷移 /newflow3
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import auth0 from 'auth0-js';
import {Link} from 'react-router'
import {checkLogin, phoneNumberregister} from './firebase'
import ToggleDisplay from 'react-toggle-display';
import './css/toast_custom.css';
import './css/newflow3.css';
import define from './define';
import Toast from './components/toast'

var webAuth = new auth0.WebAuth(define.AUTH0_CONFIG);

export default class newflow3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false,
      phoneNumber:"",
      phoneNumber_auth0:"",
      code:"",
      confirmStart:false,
      confirmOn: false,
      isConfirm: false,

      jumpURL:"/newflow5",

      success_message:''
    }
  }
  //emailの登録が完了し確認メールのURLから遷移してきた場合
  fromEmailRegister = () => {
    const {
      location
    } = this.props
    if(location.state) {
      if(location.state.hasOwnProperty('email_register')) {
        this.setState({success_message:<div className="toast-success"><p>メールアドレスの登録が完了しました</p></div>})
      }
    }
  }
  componentWillMount = () => {
    this.fromEmailRegister()
  }

  // onload
  componentDidMount() {
    var scope = this
    // ログインチェック
    checkLogin(true, function(isLogin){
      if (true === isLogin) {
        scope.setState({isLogin: true})
        var edit_config = define.AUTH0_CONFIG;
        var before_uri = scope.state.jumpURL;
        var after_uri = "/newEdit";
        edit_config.redirectUri = edit_config.redirectUri.replace(new RegExp(before_uri, "g"),after_uri);
        webAuth = new auth0.WebAuth(edit_config);
      }
    })
  }

  handleChangePhoneNumber(phoneNumber) {
    this.setState({"phoneNumber": phoneNumber});
    // 電話番号チェック
    phoneNumber = phoneNumber.replace(/[━.*‐.*―.*－.*\-.*ー]/gi,'')
    //viet nam phonenumber check
    let numberVN = this.vietnamNumbercheck(phoneNumber)
    if (numberVN) {
      this.setState({"confirmStart": true});
    } else {
        if (!phoneNumber.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
        this.setState({"confirmStart": false});
        } else {
        this.setState({"confirmStart": true});
        }
    } 
  }

  // SMS認証開始 認証コード送信
  onConfirm() {
    var phoneNumber = this.state.phoneNumber

    phoneNumber = phoneNumber.replace(/[━.*‐.*―.*－.*\-.*ー]/gi,'')

    // 正しい電話番号なら認証開始
    let numberVN = this.vietnamNumbercheck(phoneNumber)
       if (numberVN || phoneNumber.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
          this.setState({confirmOn:true});
          // +81~のように+から始まる電話番号か
          if ("+" !== phoneNumber.slice(0, 1)) {
          // 違う場合は+81に変換する処理
            phoneNumber = "+81" + phoneNumber.slice(1);
          }
          this.setState({"phoneNumber_auth0": phoneNumber});
          // 認証コード送信
          webAuth.passwordlessStart({
          connection: 'sms',
          send: 'code',
          phoneNumber: phoneNumber
      }, function (err,res) {
        if (!err) {
          //
        }
      });
    }
    
  }

  // SMS認証
  handleChangeConfirmCode(code) {

    this.setState({"code": code});

    if (6 <= code.length) {

      var phoneNumber = this.state.phoneNumber_auth0
      var scope = this
      
      phoneNumberregister(scope.state.phoneNumber)

      // 認証開始
      webAuth.passwordlessLogin({
        connection: 'sms',
        phoneNumber: phoneNumber,
        verificationCode: code
      }, function (err,res) {
        if (!err) {
          // Handle error
          //console.log("OK!");
          scope.setState({isConfirm:true});
        }
      });
    }
  }

  // 再送信
  reCodeSend(e) {
    this.setState({"confirmOn": false});
    this.setState({"code": ""});
    //this.setState({"phoneNumber": ""});
    //this.setState({"phoneNumber_auth0": ""});

  }
  // ベトナム番号か判定
  vietnamNumbercheck(phoneNumber){
    var flag = false;
    var phone = phoneNumber.trim();
    phone = phone.replace('(+84)', '0');
    phone = phone.replace('+84', '0');
    phone = phone.replace('0084', '0');
    phone = phone.replace(/ /g, '');
    if (phone !== '') {
        var firstNumber = phone.substring(0, 2);
        if ((firstNumber === '09' || firstNumber === '08') && phone.length === 10) {
            if (phone.match(/^\d{10}/)) {
                flag = true;
            }
        } else if (firstNumber === '01' && phone.length === 11) {
            if (phone.match(/^\d{11}/)) {
                flag = true;
            }
        }
    }
    return flag;
  }

  returnToast = () => {
    const {
      success_message
    } = this.state
    if(success_message) {
      return (
        <Toast notifyMessage={success_message} />
      )
    }
  }     
  render() {
      return (
    <div id="wrapper">
      {this.returnToast()}
      <div id="" className="wrapper-lp wrapper-newflow3">
        <Header parentProps={this.props} />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-newflow3">
                    <h2 className="title">Sign Up</h2>
                  <ToggleDisplay if={!this.state.isLogin}>
                    <img className="step_icon" src="/img/common/step-3@2x.png" alt="" />
                  </ToggleDisplay>
                    <img className="title_icon" src="/img/common/img_mobile.png" alt="" />
                  <p className="subtitle">
                    <ToggleDisplay if={this.state.confirmOn}>
                      認証コードを入力
                    </ToggleDisplay>
                    <ToggleDisplay if={!this.state.confirmOn}>
                      電話番号を登録しよう
                    </ToggleDisplay>
                  </p>
                  <form className="form-tel">
                    <ToggleDisplay if={this.state.confirmOn}>
                      <input type="text" name="code" className="tel" onChange={(e) => {this.handleChangeConfirmCode(e.target.value)}} />
                    </ToggleDisplay>
                    <ToggleDisplay if={!this.state.confirmOn}>
                      <input type="text" name="tel" className="tel" onChange={(e) => {this.handleChangePhoneNumber(e.target.value)}} />
                    </ToggleDisplay>
                  </form>
                  <div className="text-notification">
                    <p>MyRateアカウントを作成するには、電話番号での認証が必要です。SMS受信可能な電話番号を入力ください。上記の電話番号にSMSで認証番号をお送りします。電話番号が公開されることはありません。</p>
                  </div>
                  <div className="btnAction">
                    <ToggleDisplay if={!this.state.isConfirm}>
                      <ToggleDisplay if={this.state.confirmOn}>
                        <Link className="btn-connect">SMS認証する</Link>
                        <div className="resend">
                          <Link className="btn-resendCode" onClick={(e) => {this.reCodeSend(e)}}>認証コードを再送</Link>
                        </div>
                      </ToggleDisplay>
                      <ToggleDisplay if={!this.state.confirmOn}>
                        <Link onClick={(e) => {this.onConfirm(e)}} className="btn-connect">SMS認証する</Link>
                      </ToggleDisplay>
                    </ToggleDisplay>
                  </div>
                  
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
      )

    }
}



// WEBPACK FOOTER //
// ./src/newflow3.js